/*
  <ev-vin-box>: verificación opcional de VIN en la ficha de producto. Todo ocurre en el navegador.

  - data-prefixes: prefijos de VIN compatibles (8 caracteres, separados por coma).
  - Se verifica solo, al completar los 17 caracteres (sin botón).
  - Coincide un prefijo  -> compatible (check verde).
    Mismo fabricante (3 primeros caracteres) y otro prefijo -> "otra versión, lo confirmamos" (check celeste).
    Otro fabricante -> no coincide (cruz roja).
  - Un VIN que no empieza con L (código de fabricación en China) avisa que revise lo escrito.
  - Nunca bloquea la compra. Si el VIN tiene formato válido, se agrega al pedido como propiedad "VIN".
  - Se recuerda solo durante la visita (sessionStorage, con try/catch). No se escribe en consola.
*/
if (!customElements.get('ev-vin-box')) {
  class EvVinBox extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-ev-vin-input]');
      this.result = this.querySelector('[data-ev-vin-result]');
      this.prop = this.querySelector('[data-ev-vin-prop]');
      this.count = this.querySelector('[data-ev-vin-count]');
      this.badge = this.querySelector('[data-ev-vin-badge]');
      this.card = this.querySelector('.ev-vinbox__card');
      if (!this.input || !this.result) return;

      this.prefixes = String(this.dataset.prefixes || '')
        .split(',')
        .map((p) => p.trim().toUpperCase())
        .filter(Boolean);
      this.storageKey = 'ev-vin';

      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        this.update();
      });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.input.blur();
        }
      });

      const saved = this.readSaved();
      if (saved) {
        this.input.value = saved;
        this.update(true);
      }
    }

    text(key) {
      return this.dataset[key] || '';
    }

    setState(state) {
      if (this.card) this.card.dataset.state = state;
      if (this.badge) {
        this.badge.hidden = !state;
        this.badge.dataset.state = state;
        if (state) {
          // reinicia la animación aunque el estado se repita
          this.badge.classList.remove('is-animating');
          void this.badge.offsetWidth;
          this.badge.classList.add('is-animating');
        }
      }
      if (this.count) this.count.hidden = Boolean(state);
    }

    show(kind, message) {
      this.result.hidden = false;
      this.result.className = 'ev-vinbox__result is-' + kind;
      this.result.textContent = message;
    }

    reset() {
      this.result.hidden = true;
      this.setState('');
      if (this.prop) {
        this.prop.disabled = true;
        this.prop.value = '';
      }
    }

    readSaved() {
      try {
        const value = window.sessionStorage.getItem(this.storageKey) || '';
        return /^[A-HJ-NPR-Z0-9]{17}$/.test(value) ? value : '';
      } catch (error) {
        return '';
      }
    }

    save(vin) {
      try {
        window.sessionStorage.setItem(this.storageKey, vin);
      } catch (error) {
        /* sin almacenamiento: no pasa nada */
      }
    }

    update(silent) {
      const vin = this.input.value;
      if (this.count) this.count.textContent = vin.length + '/17';
      this.reset();
      if (vin.length < 17) return;
      this.check(vin, silent);
    }

    check(vin, silent) {
      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) {
        this.setState('no');
        this.show('invalid', this.text('msgInvalid'));
        return;
      }

      this.save(vin);
      if (this.prop) {
        this.prop.value = vin;
        this.prop.disabled = false;
      }

      const prefix = vin.slice(0, 8);
      const maker = vin.slice(0, 3);
      if (vin.charAt(0) !== 'L') {
        // La L inicial identifica a los carros fabricados en China.
        this.setState('no');
        this.show('no', this.text('msgNotChina'));
      } else if (this.prefixes.some((p) => prefix === p || (p.length < 8 && vin.startsWith(p)))) {
        this.setState('ok');
        this.show('ok', this.text('msgOk'));
      } else if (this.prefixes.some((p) => p.slice(0, 3) === maker)) {
        this.setState('partial');
        this.show('partial', this.text('msgPartial'));
      } else {
        this.setState('no');
        this.show('no', this.text('msgNo'));
      }
    }
  }

  customElements.define('ev-vin-box', EvVinBox);
}
